import {
  GetSsoUserDataQuery,
  GetSsoUserDataQueryVariables,
} from '@app/generated/graphql'
import { gql, useQuery } from 'urql'

export const GET_SSO_USER_DATA = gql`
  fragment AppMembership on AppMembershipData {
    id
    registered
    roles {
      name
      rank
    }
    organisations {
      id
      name
      urn
      addressLine1
      addressLine2
      addressLine3
      city
      country
      countryCode
      postcode
      isPrimary
      isAdmin
    }
  }

  query GetSSOUserData($input: GetSSOUserDataInput!) {
    getSSOUserData(input: $input) {
      connectProfile {
        id
        _family_name
        _given_name
        jobTitle
        phone
        country
        countryCode
        dob
        createdAt
        updatedAt
        roles {
          role {
            name
            rank
          }
        }
        organizations {
          id
          isAdmin
          organization {
            id
            address
            name
            urn
          }
        }
      }
      ssoProfile {
        id
        firstName
        lastName
        email
        dateOfBirth
        jobTitle
        phone
        residingCountry
        appMemberships {
          beSmart {
            ...AppMembership
          }
          connect {
            ...AppMembership
          }
          knowledgeHub {
            ...AppMembership
          }
        }
      }
    }
  }
`

export const useSSOUserProfile = (ssoUserId?: string, email?: string) => {
  const [{ data, error, fetching }, mutate] = useQuery<
    GetSsoUserDataQuery,
    GetSsoUserDataQueryVariables
  >({
    query: GET_SSO_USER_DATA,
    variables: {
      input: { ssoCognitoUserId: ssoUserId, email: email ?? '' },
    },
    pause: !ssoUserId && !email,
  })
  return { data, error, fetching, mutate }
}
